"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = void 0;
exports.getCountryCodes = getCountryCodes;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const geography_1 = require("../../../geography");
const common_1 = require("../common");
const error_1 = require("../error");
const http_1 = require("./http");
const NAMESPACE = 'Google.Geocode.Reverse';
class Api extends effect_1.Effect.Service()(`${NAMESPACE}.Api`, {
    effect: effect_1.Effect.fn(`${NAMESPACE}.Api.effect`)(function* (apiKey) {
        const httpClient = yield* platform_1.HttpClient.HttpClient;
        /**
         * API to resolve location metadata from coordinates - the process known as "reverse geocoding".
         *
         * See: https://developers.google.com/maps/documentation/geocoding/guides-v3/requests-reverse-geocoding
         */
        const geocode = effect_1.Effect.fn('geocode')(function* (geoPosition, options) {
            const urlParams = yield* (0, effect_1.pipe)({
                apiKey,
                geoPosition,
                language: effect_1.Option.fromNullable(options?.language),
                region: effect_1.Option.fromNullable(options?.region),
                resultTypes: effect_1.Option.fromNullable(options?.resultTypes),
                locationTypes: effect_1.Option.fromNullable(options?.locationTypes),
                extraComputations: effect_1.Option.fromNullable(options?.extraComputations),
            }, http_1.RequestParameters.make, effect_1.Schema.encode(http_1.RequestParameters));
            const responseEither = yield* (0, effect_1.pipe)(httpClient.get(common_1.JSON_API_URL, { urlParams }), effect_1.Effect.flatMap(platform_1.HttpClientResponse.schemaBodyJson(effect_1.Schema.EitherFromUnion({
                left: http_1.FailureResponse,
                right: http_1.SuccessResponse,
            }))));
            return yield* responseEither.pipe(effect_1.Effect.map(effect_1.Struct.get('results')), effect_1.Effect.catchAll(failure => (0, effect_1.pipe)(failure, effect_1.Struct.get('status'), error_1.getApiErrorConstructor, ErrorConstructor => new ErrorConstructor({
                cause: {
                    geoPosition,
                    response: failure,
                },
            }), effect_1.Effect.fail)));
        });
        return {
            geocode,
        };
    }),
}) {
}
exports.Api = Api;
/**
 * Utility function to return a list of all {@link CountryCodeIso3166Alpha2 country codes}
 * specified in a list of {@link Result reverse geocoding results}. Original order is preserved.
 */
function getCountryCodes(results) {
    return (0, effect_1.pipe)(results, effect_1.Array.flatMap(effect_1.Struct.get('address_components')), effect_1.Array.filterMap((0, effect_1.flow)(effect_1.Option.liftPredicate(component => component.types.has('country')), effect_1.Option.map(effect_1.Struct.get('short_name')), effect_1.Option.filter(effect_1.Schema.is(geography_1.CountryCodeIso3166Alpha2)))), effect_1.Array.dedupe);
}
//# sourceMappingURL=index.js.map